import React, { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import useTitanApp from "../hooks/useTitanApp";
import { handleUpdateSession } from "../data/handleUpdateSession";
import useTimer from "../hooks/useTimer";
import { setIsNewClinicComponent } from "../dispatchers/pharmacyServiceDispatchers";
import userAvatar from "./../assets/images/userAvatar.png";
import { FiUser } from "react-icons/fi";
import { CgLogOut } from "react-icons/cg";
import {
  getMemberById,
  getUsersProfile,
} from "../dispatchers/memberDispatchers";
import {
  setCurrentCompanyId,
  setShowProfileModal,
} from "../dispatchers/appDispatchers";

export default function ProfileButton() {
  const { auth, signout, appState } = useTitanApp();
  const { user } = auth || {};
  const { isOrbitUser, darkMode } = appState || {};
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event?.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = async (e) => {
    try {
      e?.preventDefault?.();
      e?.stopPropagation?.();
      handleClose();
      await new Promise((r) => setTimeout(r, 0));

      const email = user?.email || user?.emailAddress || "";
      if (email) {
        await getMemberById(email);
      }
      await getUsersProfile();

      setShowProfileModal(true);
    } catch (err) {
      console.error("Profile modal error:", err);
    }
  };

  const logout = async () => {
    if (isOrbitUser) {
      var result = await handleUpdateSession();
      if (result === true) {
        if (window.Intercom) {
          window.Intercom("shutdown");
        }
        handleReset();
        localStorage.setItem("globalTab", 0);
        localStorage.setItem("patientInfoTab", 0);
        localStorage.setItem("globalTabText", "PharmacyDashboard");
        setCurrentCompanyId("");
        signout();
      }
    } else {
      if (window.Intercom) {
        window.Intercom("shutdown");
      }
      localStorage.setItem("globalTab", 0);
      localStorage.setItem("patientInfoTab", 0);
      localStorage.setItem("globalTabText", "PharmacyDashboard");
      setCurrentCompanyId("");

      signout();
    }
    handleClose();
  };
  const { handleReset } = useTimer();

  return (
    <div>
      <div className="user-profile" onClick={handleClick}>
        <img src={user?.picture} className="profile_image" />
      </div>
      <Menu
        id="basic-menu"
        className="user-menu-action-box"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
          autoFocus: false,
        }}
        ModalProps={{
          disableAutoFocus: true,
          disableEnforceFocus: true,
          keepMounted: false,
        }}
      >
        <MenuItem className="profile_menu_item" onClick={handleProfileClick}>
          <FiUser color={darkMode ? "#bdbdbd" : "#0a0a0a"} />{" "}
          <span>Profile</span>
        </MenuItem>

        <MenuItem className="profile_menu_item" onClick={logout}>
          <CgLogOut color={darkMode ? "#bdbdbd" : "#0a0a0a"} />
          <span>Logout</span>
        </MenuItem>
      </Menu>
    </div>
  );
}
